// userInput/wheelLock.js — a container swallows the mouse wheel, so the page behind it does not scroll; elements
// marked with WHEEL_SCROLL_CLASS scroll themselves as long as they can and are blocked at their ends.
// First resident of the userInput package: mouse, wheel and keyboard behaviour of control containers, independent of
// the domain (plan bugfix_2026-10-08_polishing-patch, phase tagliste-scroll). Consumer: the documents popup.

export const WHEEL_SCROLL_CLASS = 'js-wheel-scroll';   // behaviour hook, no styling

// Pure: can the element scroll further in the wheel's direction?
export function canScrollFurther(el, deltaY) {
    if (deltaY < 0) { return el.scrollTop > 0; }
    if (deltaY > 0) { return el.scrollHeight - el.scrollTop > el.clientHeight; }
    return false;
}

// Locks the wheel on the container. Returns release().
export function lockWheel(container) {
    const onWheel = (ev) => {
        const scroller = ev.target.closest?.('.' + WHEEL_SCROLL_CLASS);
        if (scroller && container.contains(scroller) && canScrollFurther(scroller, ev.deltaY)) {
            ev.stopPropagation();   // the list scrolls natively
            return;
        }
        ev.preventDefault();
        ev.stopPropagation();
    };
    container.addEventListener('wheel', onWheel, { passive: false });   // passive:false — preventDefault must work
    return () => container.removeEventListener('wheel', onWheel);
}
